<template>
  <b-row>
    <b-col cols="8" class="container">
      <b-row>
        <LeftTab
          :complaintData="complaintData"
          :IsAllowDelete_PersonDataDigital="false"
          :IsReadOnly_PersonDataDigital="true"
          :personals="personals"
          :attorneys="attorneys"
          :IsEdit_CompanyDetail="false"
          :IsDeleteAble_CompanyDetail="false"
          :IsReadOnly_CompanyDetail="true"
          :IsEdit_CompanySearch="false"
          :complainantCompany="complainantCompany"
          :IsReadOnly_ComplaintDetail="true"
          :complaintDetail="complaintDetail"
          :complaintCatagoryDetail="complaintCatagoryDetail"
          :complaintDetailMultiSelect="complaintDetailMultiSelect"
          :company="complaintData"
          :IsEdit_TabAttachFiles="false"
          :attachFiles="attachFiles"
          :attachFileDate="attachFileDate"
          :attachFilesType2="attachFilesType2"
          :attachFileDateType2="attachFileDateType2"
          :fileFormstatusModel="fileFormstatusModel"
          :fileFormstatusModelDates="fileFormstatusModelDates"
          :fileFormstatusType3Model="fileFormstatusType3Model"
          :fileFormstatusType3ModelDates="fileFormstatusType3ModelDates"
          :fileFormstatusType4Model="fileFormstatusType4Model"
          :fileFormstatusType4ModelDates="fileFormstatusType4ModelDates"
          :IsEditData="false"
        />
      </b-row>
    </b-col>
    <b-col cols="4">
      <b-card>
        <TrackingComplaint :hightlightLasted="true" />

        <b-tabs class="mt-2">
          <b-tab id="tab-send-1" title="ส่งต่อศูนย์คัดกรอง">
            <div class="mt-2 mb-1">
              <ValidationObserver ref="form">
                <ValidationProvider
                  rules="required"
                  name="ความเห็นเจ้าหน้าที่"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    label="ความเห็นเจ้าหน้าที่"
                    label-for="offficerComment"
                    class="ml-1 mt-1"
                  >
                    <b-form-textarea
                      id="offficerComment"
                      placeholder="ความเห็นเจ้าหน้าที่"
                      rows="6"
                      v-model="comment"
                    />
                  </b-form-group>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </ValidationObserver>
            </div>
            <div class="d-flex justify-content-end">
              <b-button
                variant="primary"
                class="ml-1"
                @click="onTrackingSendScreening"
                >ส่งต่อศูนย์คัดกรอง</b-button
              >
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BFormGroup,
  BFormTextarea,
  BTab,
  BTabs,
} from "bootstrap-vue";
import LeftTab from "@/views/Complaint/components/LeftTabAction.vue";
import TrackingComplaint from "@/views/Complaint/components/TrackingComplaint/TrackingComplaint.vue";
import VueSelect from "vue-select";

import * as complaintStore from "@/store/api/complaint/complaint.js";
import * as trackingNullStore from "@/store/api/complaintManage/trackingNull.js";
import * as storeMaster from "@/store/api/master/index.js";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "กรุณากรอก{_field_}",
  computesRequired: true,
});

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BFormGroup,
    BFormTextarea,
    BTab,
    BTabs,
    LeftTab,
    TrackingComplaint,
    VueSelect,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      personals: [],
      attorneys: [],
      complainantCompany: [],
      currentUserIdModal: "",
      currentCompIdModal: "",
      currentCompanyModal: {},
      complaintData: {},
      complaintDetail: [],
      complaintDetailMultiSelect: [],
      complaintCatagoryDetail: [],
      masterIdList: [],
      complainId: null,
      attachFiles: [],
      attachFileDate: [],
      attachFilesType2: [],
      attachFileDateType2: [],
      fileFormstatusModel: [],
      fileFormstatusModelDates: [],
      fileFormstatusType3Model: [],
      fileFormstatusType3ModelDates: [],
      fileFormstatusType4Model: [],
      fileFormstatusType4ModelDates: [],

      internalDep: null,
      internalDeps: [],
      comment: "",
      province: null,
      provinces: [],
    };
  },
  mounted() {
    this.getComplaintById(this.$route.query.id);
  },
  methods: {
    onTrackingSendScreening() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        this.onSubmitBtnClicked();
      });
    },
    onSubmitBtnClicked() {
      const _this = this;

      this.$swal({
        title: "ยืนยันการบันทึกข้อมูล?",
        text: "",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const params = {
            complaintId: _this.$route.query.id,
            comment: _this.comment,
          };
          trackingNullStore
            .AddTrackingScreening(params)
            .then((response) => {
              if (response.data.success === true) {
                _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                  title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                  variant: "success",
                  solid: false,
                });
                _this.$router.go(_this.$router.currentRoute);
              } else {
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
              _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                variant: "danger",
                solid: false,
              });
            });
        }
      });
    },
    getComplaintById(id) {
      const _this = this;
      //console.log('userData.userId', userData.userId())
      //console.log('userData.departmentId', userData.departmentId())
      complaintStore
        .getComplaintById(id)
        .then(function(response) {
          // handle success

          console.log("GetComplaintById", response);

          _this.personals = response.data.data.personals;
          _this.attorneys = response.data.data.attorneys;
          _this.complaintData = response.data.data.complaintModel;
          _this.complainantCompany = response.data.data.complainantCompany;
          _this.attachFiles = response.data.data.attachFiles;
          _this.attachFileDate = response.data.data.attachFileDate;
          _this.attachFilesType2 = response.data.data.attachFilesType2;
          _this.attachFileDateType2 = response.data.data.attachFileDateType2;
          _this.fileFormstatusModel = response.data.data.fileFormstatusModel;
          _this.fileFormstatusModelDates =
            response.data.data.fileFormstatusModelDates;
          _this.fileFormstatusType3Model =
            response.data.data.fileFormstatusType3Model;
          _this.fileFormstatusType3ModelDates =
            response.data.data.fileFormstatusType3ModelDates;
          _this.fileFormstatusType4Model =
            response.data.data.fileFormstatusType4Model;
          _this.fileFormstatusType4ModelDates =
            response.data.data.fileFormstatusType4ModelDates;
          _this.complaintDetail = response.data.data.complaintDetail;
          _this.complaintDetailMultiSelect =
            response.data.data.complaintDetailMultiSelect;
          _this.complaintCatagoryDetail =
            response.data.data.complaintCatagoryDetail;

          _this.complaintDetail.forEach((value, index) => {
            value.tmMasterList.forEach((value2, index2) => {
              if (value2.checked === true) {
                _this.masterIdList.push(value2.masterId);
              }
            });
          });

          const filterAttach = _this.attachFiles.filter((value) => {
            return value.createDateStr === _this.attachFileDate[0];
          });

          console.log(
            "_this.attachFileDate",
            _this.attachFileDate,
            filterAttach
          );
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
        });
    },
    selectOnInput() {
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
